<div class="chart-container">
    <canvas baseChart  [data]="chartData" [labels]="chartLabels"
      [options]="chartOptions" [plugins]="doughnutChartPlugins" [legend]="chartLegend" [chartType]="chartType" [colors]="colors" [height]="height">
    </canvas>
  </div>